import React, { useEffect, useState } from 'react';
import cartUtils from '../../../utils/cart.utils';
import cartApis from '../../../apis/cart.api';
import { OrderInfoModel } from '../../../models/order.model';
import { ProductModel } from '../../../models/product.model';

const OrderInfo = ({ onChange }) => {
    const [listProduct, setListProduct] = useState([]);

    const fetchData = async () => {
        try {
            const cartStorage = cartUtils.get();
            if (!cartStorage) {
                return;
            }
            const listItem = JSON.parse(cartStorage);
            if (listItem.length === 0) {
                return;
            }
            const { status, data } = await cartApis.getCartInfo(listItem);

            if (status !== 200) {
                return;
            }

            const listRes = data.data;

            let listView = [];

            listItem.forEach((item) => {
                const objCheck = listRes.find((o) => o.cp_id == item.id);
                if (objCheck != null) {
                    listView = [
                        new ProductModel({
                            ...objCheck,
                            quantity: item.quantity,
                        }),
                        ...listView,
                    ];
                }
            });

            setListProduct(listView);

            if (onChange) {
                onChange(listItem);
            }
        } catch (err) {
            console.log(err);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    const showHtml = () => {
        if (listProduct.length === 0) {
            return null;
        }
        const orderInfo = new OrderInfoModel({
            listProduct,
            shipMoney: 0,
            promotionMoney: 0,
        });
        return (
            <div className="info-order">
                <div className="product-name">
                    <ul>
                        <li className="head">
                            <span className="name">Tên sản phẩm</span>
                            <span className="qty">
                                <b>Số lượng</b>
                            </span>
                            <span className="total">
                                <b>Thành tiền</b>
                            </span>
                        </li>
                        {orderInfo.listProduct.map((item, index) => {
                            return (
                                <li key={index}>
                                    <span className="name">{item.cp_name}</span>
                                    <span className="qty text-right">
                                        {item.quantity}
                                    </span>
                                    <span className="total text-right">
                                        {item.totalStr}
                                    </span>
                                </li>
                            );
                        })}
                    </ul>
                </div>

                <ul className="product-order">
                    <li>
                        <span className="left">Tạm tính</span>
                        <span className="right">{orderInfo.subTotalStr}</span>
                    </li>
                    <li>
                        <span className="left">Giảm giá</span>
                        <span className="right">
                            {orderInfo.promotionMoneyStr}
                        </span>
                    </li>
                    <li>
                        <span className="left">Phí vận chuyển</span>
                        <span className="right">{orderInfo.shipMoneyStr}</span>
                    </li>
                    <li>
                        <span className="left">Tổng tiền</span>
                        <span className="right brand">
                            {orderInfo.totalStr}
                        </span>
                    </li>
                </ul>
            </div>
        );
    };
    return (
        <>
            <h3 className="title-brand">THÔNG TIN ĐƠN HÀNG</h3>
            {showHtml()}
        </>
    );
};

OrderInfo.propTypes = {};

export default OrderInfo;
